// @flow
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import type { Dispatch } from "redux";
import queryString from "query-string";
import DOMPurify from "dompurify";
// $FlowFixMe
import cookieman from "cookieman";
import { v4 as uuid } from "uuid";
import ModalV2 from "@fdr/atomic-ui/_templates/ModalV2";
import {
  bindAll,
  get,
  forEach,
  attempt,
  isEqual,
  isEmpty,
  throttle,
  isUndefined,
  every
} from "lodash";
import axios from "axios";
// $FlowFixMe
import semver from "semver";
import geoServices from "@tvg/api/geo";
import capiRequests from "@tvg/api/capi";
import BrazeInAppMessages from "@tvg/atomic-ui/_atom/BrazeInAppMessages";
import buildColor from "@fdr/static-ui/ColorPalette";
import interceptRequests from "@tvg/perimeterx/src";
import tvgConf from "@tvg/conf";
import type { TvgConf } from "@tvg/conf/src/types";
import { createConversation, events as AlchemerEvents } from "@urp/alchemer";
import mediator from "@tvg/mediator";
import Poller from "@tvg/poller";
import buildRaceUrl from "@tvg/formatter/url";
import TvgGeolocation from "@tvg/geolocation";
import { MapImageEnum } from "@tvg/ts-types/GeoComply";
import { RegionType } from "@tvg/ts-types/Geolocation";
import LocationSplash from "@urp/location-splash";
import { parseJSONCapiMessage } from "@fdr/utils/parseJSONCapiMessage";
import {
  getAccountNumber,
  getEmail,
  getResidenceState
} from "@urp/store-selectors";
import {
  setGeoLocationState,
  getGeoLocation,
  setShowStateSelector
} from "@tvg/sh-geolocation/src/utils/requestGeolocation";
import { StartGeoComply } from "@tvg/sh-geolocation/src/components/startGeoComply";
import pluralize from "@fdr/utils/generalUtils";
import { getWalletBalances } from "@tvg/sh-utils/walletUtils";
import {
  setBlockedCountry,
  setLocationSplashOutdatedAppVersionAction,
  setLocationUnderFlowAction
} from "@urp/location-splash/src/actions";
import {
  sessionStartUpdate,
  setUserJurisdiction
} from "@fdr/shared-actions/UserActions";
import type { UserJurisdiction } from "@fdr/types/User";
import Messenger from "@tvg/messenger/src/component";
import Onboardings from "@fdr/onboardings";
import SplashLoader from "@fdr/splash-loader/src";
import ErrorPage from "@fdr/atomic-ui/_templates/ErrorPage";
import { FixedBanner } from "@fdr/atomic-ui/_molecules/MessageV2";
import { openLiveChat } from "@fdr/utils/liveChatUtils";
import { isBrazeInitialized } from "@tvg/braze";

import initializeBraze from "@tvg/braze/src/userBraze";

import { closeHandicappingStoreModal } from "@tvg/shared-actions/HandicappingStore";
import {
  setRaceAlerts,
  setUserFavoriteTracksWithId
} from "@tvg/shared-actions/UserActions";
import {
  getBetCancelIsLoadingBetCancelRequest,
  getTodayActiveCounter,
  getTodaySettledCounter,
  getActiveWageredAmountCounter,
  getSettledWageredAmountCounter,
  getTodayFutureCounter,
  getFutureWageredAmountCounter,
  getBetSocialShareIsOpen,
  getMyBetsCounterToggle,
  getBetCancelIsOpen,
  getIsApproxPayoutModalOpen,
  getIsMyBetsPastPerformanceOpen,
  getPastPerformanceModaLTitle,
  getSelectedTab,
  getSelectedSettledTab,
  getBetCancelModalToggle,
  getMyBetsStandaloneToggle
} from "@tvg/sh-lib-my-bets/redux/selectors";
import { setActiveBetsInfo } from "@fdr/my-bets/src/actions";
import MtpStatus from "@tvg/mtp-update/src";
import { RaceTracksDataProvider } from "@urp/lib-racetracks";
import {
  onTriggerJoin,
  onTriggerLogin,
  onRefreshSession,
  onFirstLoadComplete,
  triggerRefreshSession
} from "@tvg/sh-lib-account-wallet/src/utils/mobileUtils";
import { AWGlobalStyle } from "@tvg/sh-lib-account-wallet/src/components/AccountWalletWrapper/styled-components";
import { completeLogin } from "@tvg/sh-lib-account-wallet/src/session/login";
import { getCompleteLoginOptions } from "@tvg/sh-lib-account-wallet/src/utils/subscriptions";
import {
  openExternalLink,
  isMobile,
  isAndroid,
  isIos,
  isXSell,
  askLocation,
  onTriggerGeolocation
} from "@tvg/sh-utils/mobileUtils";
import RESPONSE_CODES from "@tvg/utils/responseCodesUtils";
import formatCurrency from "@tvg/formatter/currency";
import { getRegionByType } from "@tvg/utils/geoUtils";
import { getUserJurisdiction } from "@tvg/sh-utils/userJurisdictionUtils";
import {
  getUserSessionStartDate,
  getAuthTokenCookie,
  getSportsbookRegionCookie,
  createSportsbookRegionCookie,
  clearSportsbookRegionCookie,
  checkValidWageringState,
  isAccountCompliantSelector,
  isSessionExpired,
  getUserSessionData
} from "@tvg/sh-utils/sessionUtils";
import { logout } from "@tvg/sh-lib-account-wallet/src/session/logout";
import { handleAWEvents } from "@tvg/sh-utils/awUtils";

import { FeedbackMessageContext } from "@fdr/utils/contextUtils";
import { getRejectedErrorTitle } from "@tvg/sh-geolocation/src/utils/getRejectedErrorTitle";
import { geoComplySubscriptions } from "@tvg/sh-geolocation/src/utils/subscriptions";

import {
  getGeoComplyRetryStatus,
  getGeolocationMessageShown,
  getGeolocationStatus
} from "@tvg/sh-geolocation/src/redux/selectors";
import { successBrazePollerRequest } from "@tvg/braze/src/store/actions";
import { geolocationStatusClear } from "@tvg/sh-geolocation/src/redux/actions";
import type { LocationUnderFlow } from "@urp/location-splash/src/types";
import { getAwFlowsConfig } from "@tvg/sh-lib-account-wallet/src/config";
import AccountWalletModal from "@tvg/sh-lib-account-wallet/src/Modals/AccountWalletModal";
import StateSelector from "@tvg/sh-lib-account-wallet/src/components/StateSelector";
import { getCleanedUrl } from "@tvg/utils/xss";
import { amplitudeInit } from "@fdr/amplitude";
import withRouter from "@tvg/utils/withCustomRouter";
import { isURP } from "@tvg/utils/generalUtils";
import { BetSocialShareModal } from "frontend-mbl/src/shared/pages/components/Modals";
import requester from "@tvg/api/requester";
import favorites from "../services/favorites";
import getActiveBets from "../services/activeBets";
import getUserPromos, { clearOptedInPromos } from "../services/optedInPromos";
import { userBalancePollerTime } from "../services/balance";
import { getUserPreferences } from "../services/preferences";
import {
  iOSInitResponseAction,
  iOSNotificationsStateAction,
  iOSModalStatus
} from "../actions/ios";
import { successFeaturesRequest } from "../actions/capi";
import { setUserAccountNumber } from "../actions/user";
import {
  closePromosModal,
  closeCrossProductNavigationModal,
  geoComplyErrorModal,
  openPromosModal
} from "../actions/modals";
import { type State, initialState } from "../reducers/App/appReducer";
import { initialState as geoInitialState } from "../reducers/App/geoLocationReducer";
import { type State as Store } from "../reducers";
import Main from "./Main";
import Footer from "./components/Footer";
import Header from "./components/Header";
import {
  MyBetsModal,
  PromosModal,
  FeatureTogglesModal,
  HandicapStoreModal,
  TrackSelectorModal,
  RaceSelectorModal,
  WelcomeNewUserModal,
  HelpOpenModal,
  PotencialReturnModal,
  PickBetsHowItWorksModal,
  GeoComplyErrorModal,
  InvalidResidentialAddressErrorModal,
  CrossProductNavigationModal,
  ModalTopChildren,
  BetCancelModal,
  ApproxPayoutHelpModal
} from "./components/Modals";
import perf from "./utils/perf";
import { interceptor } from "./utils/routerInterceptor";
import sendGTMPageView, { sendATTracking } from "./utils/gtm";
import {
  trackingInit,
  amplitudeSessionStart,
  amplitudeSessionEnd,
  amplitudeSetLocation,
  getAmplitudeGlobalProperties
} from "./utils/amplitude";
import isSafari from "./utils/isSafari";
import styles from "./style/styles.css";
import { setHasConnection } from "../actions/app";
import pageConfig from "./utils/config";
import { applyFeaturesOverrides, getFeatures, getMessages } from "./utils/capi";
import { bannerProps } from "./utils/fixedBanner";
import { setUserFavoriteTracks } from "../actions/favorites";
import type { JoinBarConfigType, LocationFlowCallbacks } from "../types";

const MESSAGE_NAMESPACES = [
  "MobileWebApp",
  "Global",
  "Login",
  "InformationalPages",
  "BetTicket",
  "WagerRewards",
  "Homepage",
  "ResponsibleGaming",
  "RedirectEngine",
  "ProgramPage",
  "SeoData"
];

const BalancePoller = new Poller();
const PromosPoller = new Poller();
const BalancePollerTimer = new Poller();
const ActiveBetsPoller = new Poller();
const RefreshPoller = new Poller();
const RefreshSessionPoller = new Poller();

export const startUserPromosPoller = (
  dispatch: Dispatch<*>,
  accountNumber: string
) => {
  PromosPoller.start(() => getUserPromos(dispatch, accountNumber), 30000);
};

const manageEquibaseId = (toAdd: boolean) => {
  if (toAdd) {
    if (!attempt(() => window.localStorage.getItem("equibaseId"))) {
      attempt(() => window.localStorage.setItem("equibaseId", uuid()));
    }
  } else if (attempt(() => window.localStorage.getItem("equibaseId"))) {
    attempt(() => window.localStorage.removeItem("equibaseId"));
  }
};

const rcnErrorHack = () => {
  let errorEvent = get(window, "NanoEventHandlers.onError");

  if (errorEvent) {
    window.NanoEventHandlers.onError = (event) => {
      if (get(event, "data.code") !== 1007) {
        errorEvent(event);
      }
    };
  }

  const rcnScript = document.getElementById("rcnScript");

  if (rcnScript) {
    rcnScript.onload = () => {
      errorEvent = get(window, "NanoEventHandlers.onError");
      if (errorEvent) {
        window.NanoEventHandlers.onError = (event) => {
          if (get(event, "data.code") !== 1007) {
            errorEvent(event);
          }
        };
      }
    };
  }
};

const hasRaceChanged = (newSearch: string = "", oldSearch: string = "") => {
  if (newSearch.indexOf("race=") > -1 && oldSearch.indexOf("race=") > -1) {
    const params = queryString.parse(newSearch.toLowerCase());
    const oldParams = queryString.parse(oldSearch.toLowerCase());

    return params.race !== oldParams.race;
  }
  return false;
};

export const getHandicapStoreUrl = (url: string, isLogged: boolean): string => {
  // if user was already logged in and didnt have equibaseId in localStorage
  const equibaseId = attempt(() => window.localStorage.getItem("equibaseId"));

  if (!equibaseId && isLogged) {
    manageEquibaseId(true);
  }

  const deviceParameter = "device=mobile";
  const uuidParameter = `uuid=${attempt(() =>
    window.localStorage.getItem("equibaseId")
  )}`;
  const urlParameters = `${deviceParameter}&${uuidParameter}`;

  if (!url) {
    return `https://${tvgConf().config().domain.equibase}?${urlParameters}`;
  }

  return `${url}${url.includes("?") ? "&" : "?"}${urlParameters}`;
};

export const setRFRCookie = (isApp: boolean = false): void => {
  const { referrer } = document;
  const rfrParameters = {
    "12_001_0001": /https?:\/\/racing\.fanduel(\.[a-z]{2,3}){1,2}\/?/,
    "0_022_0208": /https?:\/\/www\.google(\.[a-z]{2,3}){1,2}\/?/,
    "0_023_0209": /https?:\/\/www\.bing(\.[a-z]{2,3}){1,2}\/?/,
    "0_024_0210": /https?:\/\/www\.yahoo(\.[a-z]{2,3}){1,2}\/?/
  };
  const rfrCookieExists = !document.cookie.includes("RFR=");
  const queryParams = queryString.parse(window.location.search.toLowerCase());
  const rfr = get(queryParams, "rfr", false);

  if (referrer) {
    forEach(rfrParameters, (value, key) => {
      // Don't override current rfr cookie when referrer is from tvg.com
      if (
        value.test(referrer.toLowerCase()) &&
        key !== Object.keys(rfrParameters)[0]
      ) {
        document.cookie = `RFR=${key}`;
      }
    });
  } else if (!isApp && rfrCookieExists && !rfr) {
    // set tvg.com rfr value when no referrer and no cookie is set
    document.cookie = `RFR=${Object.keys(rfrParameters)[0]}`;
  }

  if (rfr) {
    document.cookie = `RFR=${rfr}`;
  }
};

const reloadApp = (history, isSplash = true) => {
  // reload current location with force fetch from the server
  if (isSplash) {
    history.push("?splash=1");
  }
  window.location.reload(true);
};

// refresh view after comming from background
const recoverFromBackground = () => {
  let hidden;
  let visibilityChange;
  if (!isUndefined(document.hidden)) {
    hidden = "hidden";
    visibilityChange = "visibilitychange";
    // $FlowBug
  } else if (!isUndefined(document.msHidden)) {
    hidden = "msHidden";
    visibilityChange = "msvisibilitychange";
    // $FlowBug
  } else if (!isUndefined(document.webkitHidden)) {
    hidden = "webkitHidden";
    visibilityChange = "webkitvisibilitychange";
  }
  // $FlowBug
  if (!isUndefined(document.addEventListener) && !isUndefined(hidden)) {
    // $FlowBug
    document.addEventListener(
      visibilityChange,
      () => {
        window.scrollTo(0, window.scrollTop || get(window, "scrollY", 0) + 1);
      },
      false
    );
  }
};

export class Root extends Component<*, State> {
  awFlowsSDK;

  previousPath = React.createRef();

  constructor(props: *) {
    super(props);

    bindAll(this, [
      "requestBalance",
      "handleIOSEvents",
      "handleAppEvents",
      "handleMessageEvents"
    ]);

    this.tvg = tvgConf();

    // force mobile in fdr until we have tablet
    this.tvg.device = "mobile";

    if (typeof window !== "undefined") {
      setRFRCookie(setRFRCookie(isMobile(this.tvg.product)));
      rcnErrorHack();
      recoverFromBackground();
    }

    // $FlowFixMe
    let timeoutLogin;
  }

  state: State = initialState;

  componentDidMount() {
    if (
      (cookieman.get("tvg3token") || cookieman.get("x-tvgtoken")) &&
      typeof document !== "undefined"
    ) {
      cookieman.clearAll("tvg3token");
      cookieman.clearAll("x-tvgtoken");
    }

    // register start timer when not running in ios app
    if (!isMobile(this.tvg.product)) {
      perf.register(
        "app_start",
        get(window, "performance.timing.navigationStart")
      );
      perf.measure("app_start");

      if (typeof window !== "undefined" && !this.awFlowsSDK) {
        // $FlowFixMe
        this.awFlowsSDK = require("@fanduel/aw-flows-react").AWFlows;
        this.awFlowsSDK.setConfig(getAwFlowsConfig(this.tvg.environment));
      }
    }

    this.updateLayout();

    // Calculates feature overrides and throttles with the features toggles from store
    if (!isEmpty(this.props.features)) {
      const featureToggles = applyFeaturesOverrides(this.props.features);
      this.props.dispatch(successFeaturesRequest(featureToggles));
    } else {
      getFeatures(this.props.dispatch);
    }

    getMessages(MESSAGE_NAMESPACES, this.props.dispatch);
    this.getNotificationsStatus();

    handleAWEvents(
      this.awFlowsSDK,
      this.props.dispatch,
      this.cleanLoginCallback,
      () => this.props
    );

    if (isMobile(this.tvg.product)) {
      this.handleIOSEvents();
    }

    geoComplySubscriptions(
      this.props.dispatch,
      {
        twoFactorAuthStates: this.props.twoFactorAuthStates,
        wageringStates: this.props.allowedStates
      },
      this.props.geolocationGPSInvalidMessage
    );

    this.handleAppEvents();
    this.handleMessageEvents();
    this.callInterceptorMethod();

    // tries to get the user id (accountNumber) from localStorage and dispatch it to user data
    // this is useful because every component initialized by tvg-mobile will know if the user is logged, plus it's
    // account number beforehand
    attempt(() => {
      if (window.sessionStorage.getItem("userId")) {
        this.props.dispatch(
          setUserAccountNumber(window.sessionStorage.getItem("userId"))
        );
      }
    });

    // this will poll the /refresh endpoint to check if the app should be reloaded
    // if not ,this will cause a hard refresh on the next page transition
    const self = this;
    RefreshPoller.start(
      () =>
        axios.get(`${this.tvg.config("service.capi")}/devices/mobile-fdr`).then(
          ({
            data
          }: {
            data: {
              name: string,
              refreshTimestamp: string
            }
          }) => {
            if (data && data.refreshTimestamp) {
              const newRefreshTimestamp = new Date(
                data.refreshTimestamp
              ).getTime();
              if (
                newRefreshTimestamp &&
                newRefreshTimestamp > self.refreshTimestamp
              ) {
                self.hardReload = true;
              }
              self.refreshTimestamp = newRefreshTimestamp;
            }
          }
        ),
      60000
    );

    // Amplitude
    if (this.props.enableAmplitude) {
      amplitudeInit({
        getGlobalProperties: () => getAmplitudeGlobalProperties(this.props),
        extra: {
          prevPath: this.previousPath
        }
      });
      trackingInit();
    }

    if (!get(this.props, "user.isLogged")) {
      // send initial page view
      sendGTMPageView(this.props);
    }

    this.handleUnauthorizedRequest();

    // get 403 requests from perimeterx
    if (this.props.enablePerimeterX) {
      interceptRequests();
    }

    window.addEventListener("offline", () => {
      this.props.dispatch(setHasConnection(false));
    });
    window.addEventListener("online", () => {
      this.props.dispatch(setHasConnection(true));
    });

    this.pushSiftWindowVariables();
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps: *) {
    const raceChanged = hasRaceChanged(
      get(nextProps, "location.search"),
      get(this.props, "location.search")
    );

    const pathChange =
      get(nextProps, "location.pathname") !==
      get(this.props, "location.pathname");

    const hashChanged =
      get(nextProps, "location.hash") !== get(this.props, "location.hash");

    // route change
    if (pathChange || hashChanged || raceChanged) {
      perf.register("page_render");
      perf.register("page_load");
      this.setState({
        prevPath: `${this.props.location.pathname}${this.props.location.search}`
      });

      // send gtm page view
      sendGTMPageView(nextProps, pathChange || raceChanged);
    }

    // first load of component with user data
    if (
      this.props.user.isLogged === nextProps.user.isLogged &&
      nextProps.user.accountNumber !== "" &&
      nextProps.user.homeState !== "" &&
      this.props.user.homeState === ""
    ) {
      // send gtm page view
      sendGTMPageView(nextProps);
    }

    if (
      nextProps.hasPromoBadge &&
      nextProps.hasPromosOptedIn &&
      this.props.hasPromosOptedIn &&
      nextProps.user.isLogged &&
      nextProps.user.accountNumber &&
      nextProps.user.accountNumber !== "" &&
      !PromosPoller.isRunning()
    ) {
      startUserPromosPoller(this.props.dispatch, nextProps.user.accountNumber);
    }

    if (
      (this.props.hasPromosOptedIn !== nextProps.hasPromosOptedIn ||
        !nextProps.user.isLogged) &&
      PromosPoller.isRunning()
    ) {
      PromosPoller.stop();
      clearOptedInPromos(this.props.dispatch);
    }

    if (
      nextProps.user.accountNumber &&
      nextProps.user.isLogged &&
      (nextProps.user.isLogged !== this.props.user.isLogged ||
        this.props.user.accountNumber !== nextProps.user.accountNumber)
    ) {
      if (!this.props.behgToggle) {
        this.startActiveBetsPoller(nextProps.user.accountNumber);
      }

      if (this.props.enableAmplitude) {
        amplitudeSessionStart(nextProps);
      }
    }

    if (
      this.props.enableAmplitude &&
      this.props.user.isLogged &&
      this.props.geolocation.state !== nextProps.geolocation.state &&
      nextProps.geolocation.state
    ) {
      amplitudeSetLocation(nextProps.geolocation.state);
    }

    if (this.props.user.isLogged && !nextProps.user.isLogged) {
      ActiveBetsPoller.stop();
      PromosPoller.stop();

      if (this.props.enableAmplitude) {
        amplitudeSessionEnd();
      }
    }

    if (
      !isEqual(nextProps.user.isLogged, this.props.user.isLogged) ||
      !isEqual(nextProps.user.accountNumber, this.props.user.accountNumber) ||
      !isEqual(nextProps.user.balancePoller, this.props.user.balancePoller)
    ) {
      this.updateBalanceRequest(
        nextProps.user.isLogged,
        nextProps.user.accountNumber,
        nextProps.user.balancePoller
      );
    }

    if (
      nextProps.user.isLogged !== this.props.user.isLogged ||
      nextProps.user.accountNumber !== this.props.user.accountNumber
    ) {
      this.refreshSession(nextProps.user.isLogged);

      if (nextProps.user.isLogged) {
        getUserPreferences(
          nextProps.user.accountNumber,
          this.props.dispatch,
          this.props.overwritePreferences,
          isXSell()
        );
      }
    }

    if (!BalancePollerTimer.isRunning()) {
      BalancePollerTimer.start(this.requestBalanceTimer, 300000);
    }
  }

  shouldComponentUpdate(nextProps: *, nextState: *) {
    if (nextState.prevPath !== this.state.prevPath)
      this.previousPath.current = nextState.prevPath;

    return !isEqual(nextProps, this.props) || !isEqual(nextState, this.state);
  }

  shouldForceAndroidUpdate = (
    capiVersion: string,
    androidAppVersion: string
  ) => {
    const splittedCapiVersion = +capiVersion.split(".").join("");
    const splittedAppVersion = +androidAppVersion.split(".").join("");
    return splittedAppVersion < splittedCapiVersion;
  };

  checkNeedsUpdateScreen() {
    const { appVersion, capiIOSForceUpdateFDR } = this.props;
    const forceUpdateIOS = get(capiIOSForceUpdateFDR, "forceUpdate", false);
    const forceUpdateAndroid = get(
      capiIOSForceUpdateFDR,
      "forceUpdateAndroid",
      false
    );

    try {
      const needShowInIos =
        forceUpdateIOS &&
        isIos(this.tvg.product) &&
        !this.state.hasShownForceUpdate;
      const needsToShowInAndroid =
        forceUpdateAndroid && isAndroid(this.tvg.product);
      let shouldUpdate = false;

      if (needShowInIos) {
        const minimumVersionIOS = get(capiIOSForceUpdateFDR, "minimumVersion");
        shouldUpdate = !appVersion || semver.lt(appVersion, minimumVersionIOS);
      } else if (needsToShowInAndroid) {
        const minimumVersionAndroid = get(
          capiIOSForceUpdateFDR,
          "minimumVersionAndroid"
        );
        shouldUpdate =
          !appVersion ||
          (this.shouldForceAndroidUpdate(minimumVersionAndroid, appVersion) &&
            !this.state.hasShownForceUpdate);
      }

      if (shouldUpdate) {
        this.props.dispatch(setLocationSplashOutdatedAppVersionAction());
        this.setState({ hasShownForceUpdate: shouldUpdate });
      }
    } catch (err) {
      console.log("Something went wrong with force app update screen", err);
    }
  }

  componentDidUpdate(prevProps: *) {
    if (
      this.props.raceDate &&
      prevProps.raceDate &&
      this.props.raceDate !== prevProps.raceDate
    ) {
      reloadApp(this.props.history, false);
    }

    if (
      document.body &&
      !document.querySelector('[data-qa-label="modal-header"]') &&
      this.props.location !== prevProps.location
    ) {
      document.body.classList.toggle("modal", false);
    }

    if (!isXSell() && this.props.mobileLaunchTimestamp > 0) {
      this.checkNeedsUpdateScreen();
    }

    this.updateLayout();

    if (
      this.props.location !== prevProps.location ||
      this.props.history !== prevProps.history ||
      this.props.user.isLogged !== prevProps.user.isLogged
    ) {
      this.callInterceptorMethod(prevProps);
    }

    if (this.props.user.fdUserId !== prevProps.user.fdUserId) {
      this.pushSiftWindowVariables();
    }

    if (
      typeof window !== "undefined" &&
      get(prevProps, "location.pathname") !==
        get(this.props, "location.pathname")
    ) {
      window.scrollTo(0, 0);

      // detect when we must hard reload because new build is available
      if (this.hardReload) {
        reloadApp(this.props.history, true);
      }
    }

    // bind this context to setState to use on a regular function
    const setState = this.setState.bind(this);

    const authToken = getAuthTokenCookie();

    initializeBraze(
      prevProps,
      this.props,
      this.state.subscription,
      setState,
      this.props.dispatch,
      this.getBrazeUserId(authToken, prevProps.user.fdUserId),
      this.getBrazeUserId(authToken, this.props.user.fdUserId)
    );
  }

  getNotificationsStatus = () => {
    if (isMobile(this.tvg.product)) {
      mediator.ios.subscribe("PUSH_NOTIFICATION_STATE", (data) => {
        if (!data.error) {
          this.props.dispatch(
            iOSNotificationsStateAction(
              get(data, "payload.pushNotificationEnabled")
            )
          );
        }
      });

      mediator.ios.dispatch({
        type: "ASK_PUSH_NOTIFICATION_STATE",
        payload: { silent: true }
      });
    }
  };

  loginCallback = null;

  pushSiftWindowVariables = () => {
    if (
      !!this.props.user.fdUserId &&
      window._sift[1] !== ["_setUserId", `${this.props.user.fdUserId}`] &&
      this.props.featureToggles.enableSift &&
      this.props.user.isLogged &&
      !isMobile()
    ) {
      const authToken = getAuthTokenCookie();
      const tokenUserData = getUserSessionData(authToken);

      window._sift.push(["_setUserId", `${this.props.user.fdUserId}`]);
      window._sift.push(["_setSessionId", `${tokenUserData.sessionId || ""}`]);
      window._sift.push(["_trackPageview"]);
    }
  };

  validateSessionExpired = (error: {
    response: { status: number, data: { code: number } }
  }) => {
    if (
      error.response?.status === RESPONSE_CODES.AUTHENTICATION_ERROR &&
      this.props.user.isLogged &&
      !isXSell()
    ) {
      logout();
      this.props.history.push("/");
      if (typeof window !== "undefined") {
        window.location.reload();
      }
    }
    return Promise.reject(error);
  };

  handleUnauthorizedRequest = () => {
    // Force logout when tokens aren't valid - 401
    requester().interceptors.response.use(
      (res) => res,
      (error) => this.validateSessionExpired(error)
    );

    axios.interceptors.response.use(
      (response) => Promise.resolve(response),
      (error) => this.validateSessionExpired(error)
    );
  };

  /** 🛑 STOP! Hammer time! 🔨 Na, na, na... can't touch this! 👷
   * The overflow on tablet in safari needs to be hidden because the program page and
   * wager rewards opt-in layout is fixed due to issues with scrolling and contents being under the footer
   */ isFixedLayout = () =>
    (isSafari(true) &&
      this.tvg.device === "tablet" &&
      this.tvg.product === "touch3" &&
      (this.props.location.pathname.indexOf("/racetracks") === 0 ||
        this.props.location.pathname.indexOf("/live") === 0)) ||
    (this.props.location.pathname.indexOf("/wager-rewards") === 0 &&
      !this.props.user.isLogged);

  updateLayout = () => {
    if (document.body && document.documentElement && this.isFixedLayout()) {
      // $FlowBug
      document.body.classList.toggle("no-overflow", true);
      // $FlowBugs
      document.documentElement.classList.toggle("no-overflow", true);
    } else if (document.body && document.documentElement) {
      // $FlowBug
      document.body.classList.toggle("no-overflow", false);
      // $FlowBug
      document.documentElement.classList.toggle("no-overflow", false);
    }
  };

  requestBalanceTimer = () => userBalancePollerTime(this.props.dispatch);

  requestBalance = throttle(
    () => getWalletBalances(this.props.dispatch),
    2000,
    { trailing: false }
  );

  tvg: TvgConf;

  refreshTimestamp: number;

  hardReload: boolean = false;

  startActiveBetsPoller(accountNumber: string) {
    ActiveBetsPoller.start(
      () =>
        getActiveBets(accountNumber).then((r) =>
          this.props.dispatch(
            setActiveBetsInfo({
              bets: r.groups,
              totalBets: r.totalCount,
              totalAmount: r.totalAmount
            })
          )
        ),
      30000
    );
  }

  checkGeolocation() {
    return (
      this.props.geolocation.location?.latitude &&
      this.props.geolocation.location?.longitude &&
      this.props.geolocation.state
    );
  }

  getGeolocation(
    locationUnderFlow: LocationUnderFlow,
    callbacks?: LocationFlowCallbacks
  ) {
    if (isMobile(tvgConf().product)) {
      askLocation();
      if (callbacks && typeof callbacks.mobile === "function") {
        callbacks.mobile();
      }
    } else {
      this.props.dispatch(setLocationUnderFlowAction(locationUnderFlow));
      if (callbacks && typeof callbacks.web === "function") {
        callbacks.web();
      }
    }
  }

  cleanLoginCallback = () => {
    this.loginCallback = null;
  };

  getBrazeUserId = (authToken: string, userId?: string) => {
    return (userId ?? getUserSessionData(authToken).fdUserId).toString();
  };

  // eslint-disable-next-line react/sort-comp
  handleAppEvents() {
    mediator.base.subscribe("FDR_LOGIN:USER_SESSION_UPDATE", (data) => {
      const { user } = data.payload;
      const isLogged = get(data, "payload.logged", false);
      const isVerified = get(data, "payload.isVerified", false);
      const authToken = getAuthTokenCookie();
      let brazeUserId = "";

      capiRequests.fetchBrazePollerTime().then((response) => {
        this.props.dispatch(successBrazePollerRequest(+response.data.value));
      });

      if (!user.accountNumber && !isLogged) {
        return;
      }
      if (user && isLogged) {
        // As apptentive is initialized with and id from other app we should use this piece of code
        // when we have fdr app id
        createConversation(user);
        AlchemerEvents.login();
      }

      brazeUserId = this.getBrazeUserId(authToken, user.fdUserId);

      if (authToken) {
        if (!user.sessionStartAt) {
          this.props.dispatch(
            sessionStartUpdate(getUserSessionStartDate(authToken))
          );
        }

        if (!isVerified) {
          return;
        }
      }

      if (!this.props.userFavoriteTracksLoaded) {
        favorites
          .getUserFavoriteTracks(user.accountNumber)
          .then((favoriteTracks) => {
            const actualFavoriteTracks = Object.keys(favoriteTracks);
            this.props.dispatch(setUserFavoriteTracks(actualFavoriteTracks));
            this.props.dispatch(setUserFavoriteTracksWithId(favoriteTracks));
          })
          .then(() => mediator.base.dispatch({ type: "GOT_FAVORITE_TRACKS" }));
      }

      if (isMobile(this.tvg.product)) {
        // get all race alerts subscriptions from ufc service
        favorites
          .getUserRaceAlerts(user.accountNumber, "race")
          .then((raceAlertsList) => {
            this.props.dispatch(setRaceAlerts(raceAlertsList));
          })
          .catch(() => {
            this.props.dispatch(setRaceAlerts([]));
          });
        mediator.ios.dispatch({
          type: "LOGIN_SUCCESS",
          payload: {
            pushAccountId: brazeUserId,
            accountId: user.emailAddress ?? user.email,
            token: user.pin
          }
        });
      }
    });

    mediator.base.subscribe("OPEN_SIGNUP", (data) => {
      mediator.base.dispatch({
        type: "REGISTRATION:MODAL_OPEN",
        payload: {
          module: get(data, "module", "join_bar")
        }
      });

      return (this.checkGeolocation() && getSportsbookRegionCookie()) ||
        isXSell()
        ? onTriggerJoin(this.awFlowsSDK)
        : this.getGeolocation("SIGN_UP");
    });

    mediator.base.subscribe("OPEN_LOGIN_SUCCESS", (data) => {
      const { user, jurisdiction, isVerified } = get(data, "payload");

      mediator.base.dispatch({
        type: "FETCH_QUICKLINKS"
      });
      // Call callback
      if (typeof this.loginCallback === "function") {
        if (isVerified && jurisdiction?.accepted) {
          const error = null;
          const success = {
            status: "success",
            data: {
              userDetails: user
            }
          };
          this.loginCallback(error, success);
        }
      }

      // Reset it again
      this.cleanLoginCallback();
    });

    mediator.base.subscribe("OPEN_LOGIN", (data) => {
      const callback = get(data, "payload.callback");
      const hasCallback = typeof callback === "function";
      const hasGeolocation = this.checkGeolocation();

      mediator.base.dispatch({
        type: "LOGIN_MODAL_OPENED",
        payload: {
          module: get(data, "module", "join_bar")
        }
      });

      // When in XSell and FDR isn't yet aware of the user session
      // wait for launchInRegion dispatch from SBK to provide context.
      // getSportsbookRegionCookie() === launchInRegion dispatched
      // getAuthTokenCookie() === user has session started in SBK
      const userIsLogged = this.props.user.isLogged;
      const hasPossibleWebSession =
        !isMobile() && getAuthTokenCookie() && getSportsbookRegionCookie();

      const hasXSellReceivedSessionEvent =
        isXSell() && getSportsbookRegionCookie();

      if (isXSell() || hasPossibleWebSession) {
        if (hasXSellReceivedSessionEvent || userIsLogged) {
          if (this.state.openLoginRetryCounter > 0) {
            this.setState({
              openLoginRetryCounter: 0
            });
          }

          if (getAuthTokenCookie()) {
            if (isXSell()) {
              completeLogin(
                getAuthTokenCookie(),
                this.props.dispatch,
                getSportsbookRegionCookie(),
                getCompleteLoginOptions(this.props.user.userName)
              );
            }
            if (hasCallback) {
              const error = null;
              const success = {
                status: "success",
                data: {
                  userDetails: this.props.user
                }
              };
              callback(error, success);
            }
            return;
          }
        } else if (this.state.openLoginRetryCounter < 3) {
          this.setState((prevState) => ({
            openLoginRetryCounter: prevState.openLoginRetryCounter + 1
          }));
          // $FlowFixMe
          if (this.timeoutLogin) {
            // $FlowFixMe
            clearTimeout(this.timeoutLogin);
          }
          // $FlowFixMe
          this.timeoutLogin = setTimeout(
            () => mediator.base.dispatch(data),
            500
          );
          return;
        } else if (
          hasPossibleWebSession &&
          this.state.openLoginRetryCounter === 3
        ) {
          mediator.base.dispatch({ type: "TRIGGER_LOGOUT" });
          return;
        }
      }

      if ((hasGeolocation && getSportsbookRegionCookie()) || isXSell()) {
        onTriggerLogin(this.awFlowsSDK);
      } else {
        this.getGeolocation("LOGIN", {
          mobile: () => {
            onTriggerLogin(this.awFlowsSDK);
          }
        });
      }

      if (hasCallback) {
        this.loginCallback = callback;
      }
    });

    mediator.base.subscribe("GET_USER_JURISDICTION", () => {
      const { dispatch } = this.props;
      getUserJurisdiction().then((jurisdiction: UserJurisdiction) => {
        dispatch(setUserJurisdiction(jurisdiction));
      });
    });
  }

  checkCountryAndroid = (data: { latitude: number, longitude: number }) => {
    if (this.tvg.product === "androidwrapper") {
      geoServices
        .getRegion(data)
        .then((response) => get(response, "data"))
        .then((regionData) => {
          const region = getRegionByType(
            get(regionData, "regions", []),
            RegionType.STATE
          );
          if (region) {
            this.props.dispatch(setBlockedCountry(region.id === 0));
          }
        })
        .catch(() => null);
    }
  };

  // This is for the iOS and android app
  handleIOSEvents() {
    const { allowedStates, dispatch } = this.props;
    const { isIOSEventsSubsRunning } = this.state;

    if (!isMobile(this.tvg.product) || isIOSEventsSubsRunning) {
      return;
    }

    this.setState({ isIOSEventsSubsRunning: true });
    const setGeoLocationData = (data) => {
      TvgGeolocation.setLocation(data.latitude, data.longitude).then(
        (locationData) => {
          const state = get(data, "state");
          const isUserStateAllowedBets = checkValidWageringState(
            state,
            allowedStates
          );
          const cachedRegion = getSportsbookRegionCookie();

          if (!checkValidWageringState(cachedRegion, allowedStates)) {
            clearSportsbookRegionCookie();
          }

          if (!getSportsbookRegionCookie() && isUserStateAllowedBets) {
            createSportsbookRegionCookie(state);
          }

          const sbkRegionCookie = getSportsbookRegionCookie();
          if (!sbkRegionCookie) {
            dispatch(setShowStateSelector(true));
          } else {
            dispatch(setGeoLocationState(sbkRegionCookie));
          }

          dispatch(getGeoLocation({ ...locationData, state }));
        }
      );
    };
    // Subscribe to iOS init response
    mediator.ios.subscribe("INIT_RESPONSE", (data) => {
      let initResponse = get(data, "payload", {});

      if (tvgConf().product === "ios2") {
        initResponse = {
          ...initResponse,
          touchIdAvailable: false,
          touchIdEnabled: false
        };
      }
      this.props.dispatch(iOSInitResponseAction(initResponse));
      if (!every(get(data, "payload.location"), isEmpty)) {
        this.checkCountryAndroid(get(data, "payload.location"));
        setGeoLocationData(data.payload.location);
      }
      window.navigator.connection = {
        effectiveType: get(data, "payload.internetConnectionType")
      };
      if (get(data, "payload.launchTimestamp") > 0) {
        perf.register(
          "app_start",
          parseInt(data.payload.launchTimestamp * 1000, 10)
        );
        perf.measure("app_start");
      }
    });
    // Subscribe to iOS location updates
    mediator.ios.subscribe("LOCATION_RESPONSE", (data) => {
      const { user } = this.props;

      if (
        get(data, "payload.location.latitude") &&
        get(data, "payload.location.longitude")
      ) {
        this.checkCountryAndroid(get(data, "payload.location"));
        setGeoLocationData(data.payload.location);
      } else {
        dispatch(getGeoLocation(geoInitialState));

        if (user.isLogged) {
          triggerRefreshSession();
          logout();
        }
      }
    });
    // Subscribe to iOS ATTracking response
    mediator.ios.subscribe("TRACKING_RESPONSE", (data) => {
      sendATTracking(get(data, "payload.tracking", {}));
    });

    // Subscribe to warm startup event
    mediator.ios.subscribe("HOT_START", (data) => {
      const idleTime = parseInt(
        get(data, "payload.restartTimestamp") * 1000,
        10
      );
      if (idleTime > 0) {
        perf.register("app_start_hot", idleTime);
        perf.measure("app_start_hot");
      }
      // lets check again if the user changed the notification setting for tvg app
      mediator.ios.dispatch({
        type: "ASK_PUSH_NOTIFICATION_STATE",
        payload: { silent: true }
      });

      const authToken = getAuthTokenCookie();
      const isAuthTokenExpired = isSessionExpired(authToken);

      if (authToken && isAuthTokenExpired) {
        logout();
        onTriggerLogin(this.awFlowsSDK);
      }
    });

    mediator.ios.subscribe("IOS_PUSH_NOTIFICATION", (data) => {
      const fullUrl = get(data, "payload.url", "");
      const url =
        fullUrl.indexOf("://") > -1 ? fullUrl.split("://")[1] : fullUrl;
      const { trackAbbr, trackName, raceNumber } = queryString.parse(url);
      if (trackAbbr && trackName && raceNumber) {
        this.props.history.push(buildRaceUrl(trackAbbr, trackName, raceNumber));
      } else if (url) {
        this.props.history.push(`/${url}`);
      }
    });
    mediator.ios.subscribe("USER_CLOSED_MODAL", (data) => {
      const modalStatus = get(data, "payload.modalStatus");
      dispatch(iOSModalStatus(modalStatus));
    });

    // Send event to iOS app when app is initialized
    mediator.ios.dispatch({
      type: "@@INIT"
    });

    askLocation();
    onFirstLoadComplete();
  }

  handleMessageEvents() {
    // add message event listener to allow Promos to dispatch actions
    if (typeof window === "object") {
      window.addEventListener("message", (event) => {
        const path = get(this.props, "location.pathname");
        const parameters = get(this.props, "location.search");
        const currentPath = `${path}${parameters}`;
        const payload = DOMPurify.sanitize(get(event, "data.payload", ""));

        // TODO: confirm events supported!!!
        switch (get(event, "data.type")) {
          case "open_login":
            mediator.base.dispatch({ type: "OPEN_LOGIN" });
            break;
          case "close_promos":
            this.props.history.push(currentPath);
            this.props.dispatch(closePromosModal());
            break;
          case "close_handicapping":
            this.props.history.push(currentPath);
            this.props.dispatch(closeHandicappingStoreModal());
            break;
          case "open_url":
            {
              const url = getCleanedUrl(payload);
              openExternalLink(url);
            }
            break;
          case "open_page":
            {
              const pageUrl = getCleanedUrl(payload);
              this.props.history.push(pageUrl);
            }
            break;
          default:
            return false;
        }
        return true;
      });
    }
  }

  updateBalanceRequest(
    isLogged: boolean,
    accountNumber: ?number,
    balancePoller: number
  ) {
    if (!isLogged) {
      BalancePoller.stop();
    } else if (accountNumber) {
      BalancePoller.start(
        () => this.requestBalance(accountNumber, true),
        balancePoller * 1000
      );
    }
  }

  refreshSession(isLogged: boolean) {
    if (isXSell()) return;
    if (isLogged) {
      RefreshSessionPoller.start(
        () => onRefreshSession(this.awFlowsSDK),
        this.props.refreshSessionPollerTimer
      );
    } else {
      RefreshSessionPoller.stop();
    }
  }

  shouldRenderFooter = (config: *) => {
    if (isURP) {
      return !this.props.isBetslipOpen;
    }
    return get(config, "isVisible", true) && this.props.isFooterVisible;
  };

  shouldRenderJoinBar = (config?: JoinBarConfigType) => {
    return get(config, "isVisible", true) && !this.props.user.isLogged;
  };

  callInterceptorMethod(prevProps?: *) {
    interceptor(
      prevProps?.location,
      this.props.location,
      this.props.dispatch,
      this.props.history,
      this.props.user.isLogged,
      this.props.user.isAccountCompliant,
      this.props.myBetsStandaloneToggle
    );
  }

  openLogin = () => {
    mediator.base.dispatch({
      type: "OPEN_LOGIN"
    });
  };

  openSignUp = () => {
    mediator.base.dispatch({
      type: "OPEN_SIGNUP"
    });
  };

  modalTopChildren = () => (
    <ModalTopChildren
      isFullHeightModal
      toastCallback={() => this.props.dispatch(geolocationStatusClear())}
    />
  );

  handleStateSelectorClose = () => {
    if (this.props.modal.promosOpen) {
      this.props.dispatch(openPromosModal());
    }
  };

  render() {
    const path = get(this.props, "location.pathname");
    const parameters = get(this.props, "location.search");
    const currentPath = `${path}${parameters}`;
    const queryParameters = queryString.parse(parameters);
    const isFixed = this.isFixedLayout();
    const myBetsStandaloneEnabled = this.props.myBetsStandaloneToggle;

    // TODO - move this part inside the apps/frontend-fdm/src/shared/pages/Config.js after removing the feature toggle
    const educationalHubHeader = {
      title: "Horse Racing 101",
      backgroundColor: "white",
      color: "black",
      arrowColor: "black",
      fontSize: 20,
      height: 60,
      iconSize: 28,
      align: "center",
      isSticky: true,
      hasBottomBorder: true
    };

    const {
      header: pageHeaderCfg,
      footer: pageFooterCfg,
      joinBar: pageJoinBarCfg
    } = pageConfig.getComponentCfg(path, {
      overridesByExactKeys: {
        "/account": {
          header: {
            onlyBanner: !this.props.disableGWallet && this.props.user.isLogged
          }
        },
        "/tutorials": {
          header: {
            ...(this.props.enableEducationalHub ? educationalHubHeader : {})
          }
        },
        "/racetracks": {
          header: {
            isVisible: isXSell() || !isURP
          }
        },
        "/live": {
          header: {
            isVisible: false
          },
          joinBar: {
            isVisible: !this.props.enableURPWatchFDTV
          }
        }
      }
    }) || {};
    const showJoinBar = this.shouldRenderJoinBar(pageJoinBarCfg);

    const isGeolocationError = !isEmpty(this.props.geolocationError);
    const geoState = get(this.props.geolocation, "state");

    const bannerPropsValues = bannerProps(
      this.props.dispatch,
      this.props.user,
      this.props.accountCompliantBannerMsg,
      this.props.geolocationBannerMsg,
      this.props.geolocationStatus
    );

    return (
      <FeedbackMessageContext.Provider
        value={{
          toastProps: {
            ...this.props.geoLocationToastMsg[this.props.geolocationStatus],
            isMessageShown: this.props.geolocationMessageShown,
            showToast: isXSell()
              ? false
              : get(
                  this.props.geoLocationToastMsg,
                  `${this.props.geolocationStatus}.showToast`,
                  false
                )
          },
          bannerProps: bannerPropsValues
        }}
      >
        <Fragment>
          <AWGlobalStyle />
          {this.props.brazeHeaderInAppMessaging && isBrazeInitialized() && (
            <BrazeInAppMessages device={get(this.tvg, "device")} />
          )}
          <StartGeoComply
            geoState={geoState}
            isLogged={get(this.props.user, "isLogged")}
            geoComplyRetryStatus={this.props.geoComplyRetryStatus}
            isApp={isMobile(this.tvg.product)}
          />
          <Header
            title={get(pageHeaderCfg, "title")}
            logoMod={get(pageHeaderCfg, "logoMod")}
            hasCrossNavigation={get(pageHeaderCfg, "isCrossNavigationShown")}
            isActionToolsShown={get(pageHeaderCfg, "isActionToolsShown")}
            backgroundColor={get(
              pageHeaderCfg,
              "backgroundColor",
              buildColor("navy")
            )}
            color={get(pageHeaderCfg, "color", buildColor("white", "100"))}
            arrowColor={get(
              pageHeaderCfg,
              "arrowColor",
              buildColor("white", "100")
            )}
            fontSize={get(pageHeaderCfg, "fontSize")}
            iconSize={get(pageHeaderCfg, "iconSize")}
            height={get(pageHeaderCfg, "height")}
            align={get(pageHeaderCfg, "align")}
            isSticky={get(pageHeaderCfg, "isSticky")}
            hasBottomBorder={get(pageHeaderCfg, "hasBottomBorder")}
            currentPath={currentPath}
            prevPath={get(pageHeaderCfg, "prevPath", this.state.prevPath)}
            isLogged={this.props.user.isLogged}
            isVisible={get(pageHeaderCfg, "isVisible", true)}
            onlyBanner={get(pageHeaderCfg, "onlyBanner", false)}
            device="mobile"
            isApp={isMobile(this.tvg.product)}
            geoComplyRetryStatus={this.props.geoComplyRetryStatus}
            geoState={geoState}
            geolocationStatus={
              isXSell() ? this.props.geolocationStatus : undefined
            }
          >
            {bannerPropsValues && <FixedBanner {...bannerPropsValues} />}
          </Header>

          <Fragment>
            <RaceTracksDataProvider />
            <MtpStatus>
              <Main
                key="main"
                prevPath={this.state.prevPath}
                isLogged={this.props.user.isLogged}
                device={get(this.tvg, "device")}
                product={get(this.tvg, "product")}
                isFooterVisible={this.shouldRenderFooter(pageFooterCfg)}
                isFullScreen={
                  !get(pageFooterCfg, "isVisible", true) ||
                  (isURP && this.props.isBetslipOpen)
                }
                isHeaderVisible={get(pageHeaderCfg, "isVisible", true)}
                toggles={{
                  wagerRewardsApp: this.props.wagerRewardsApp,
                  enablePromosStoryblok: this.props.enablePromosStoryblok,
                  useEmailUnsubscribe: get(
                    this.props.featureToggles,
                    "useEmailUnsubscribe",
                    false
                  ),
                  useEmailSubscribe: get(
                    this.props.featureToggles,
                    "useEmailSubscribe",
                    false
                  ),
                  tracksPageOld: !get(
                    this.props.featureToggles,
                    "tracksPageNew",
                    false
                  ),
                  tracksPageNew: get(
                    this.props.featureToggles,
                    "tracksPageNew",
                    false
                  ),
                  enableURPWatchFDTV: get(
                    this.props.featureToggles,
                    "enableURPWatchFDTV",
                    false
                  )
                }}
                isBeta={this.props.isBeta}
                isFixed={isFixed}
                hasJoinBar={showJoinBar}
                hasBettingError={isGeolocationError}
              />
            </MtpStatus>
            <Footer
              activePath={currentPath || ""}
              isLogged={this.props.user.isLogged}
              isAccountCompliant={this.props.user.isAccountCompliant}
              isVisible={this.shouldRenderFooter(pageFooterCfg)}
              isVisibleJoinBar={showJoinBar}
              onLogin={this.openLogin}
              onJoin={this.openSignUp}
              device={get(this.tvg, "device")}
              talentPicksPageEnable={this.props.talentPicksPageEnable}
              isPromosEnabled={this.props.isPromosEnabled}
              isBalanceShown={this.props.isBalanceShown !== "0"}
              history={this.props.history}
              toastCallback={() => {
                const isModalOpen =
                  this.props.modal.promosOpen ||
                  this.props.myBetsOpen ||
                  this.props.modal.accountWallet.open ||
                  this.props.modal.featureTogglesOpen ||
                  this.props.modal.trackSelectorOpen ||
                  this.props.modal.raceSelectorOpen;

                !isModalOpen && this.props.dispatch(geolocationStatusClear());
              }}
              enableNoLoginRequiredForAccountPage={
                this.props.enableNoLoginRequiredForAccountPage
              }
            />
          </Fragment>
          <MyBetsModal
            title={
              this.props.isActiveBetsModal ? "Bets on this race" : "Racing Bets"
            }
            subtitle={
              this.props.isActiveBetsModal || this.props.isBalanceShown === "0"
                ? ""
                : `BALANCE: ${formatCurrency(this.props.user.balance)}`
            }
            isVideoShown={this.props.showVideo}
            isOpen={
              myBetsStandaloneEnabled
                ? this.props.modal.myBetsStandaloneOpen
                : this.props.modal.myBetsOpen
            }
            qaLabel={
              this.props.isActiveBetsModal ? "modal-activeBets" : "modal-myBets"
            }
            dispatch={this.props.dispatch}
            history={this.props.history}
            currentPath={currentPath}
            currentRace={this.props.currentRace}
            device={get(this.tvg, "device")}
            isActiveBetsModal={this.props.isActiveBetsModal}
            activeBetsNumber={
              this.props.isActiveBetsModal
                ? get(
                    this.props,
                    `racesActiveBets.${this.props.currentTvgRaceId}`,
                    0
                  )
                : 0
            }
            useCloseLabel={!this.props.isActiveBetsModal}
            hideFixedBanner={
              this.props.isActiveBetsModal && this.props.showVideo
            }
            myBetsStandaloneToggle={myBetsStandaloneEnabled}
            isPastPerformanceOpen={
              this.props.modal.myBetsStandalonePastPerformanceOpen
            }
            pastPerformanceTitle={
              this.props.modal.myBetsStandalonePastPerformanceTitle
            }
            selectedTab={this.props.myBetsStandalone.selectedTab}
            selectedSettledTab={this.props.myBetsStandalone.selectedSettledTab}
            loadMoreWagerGroups={
              this.props.myBetsStandalone.loadMoreWagerGroups
            }
            activeBetsCounter={this.props.modal.activeBetsCounter}
            settledBetsCounter={this.props.modal.settledBetsCounter}
            futureBetsCounter={this.props.modal.futureBetsCounter}
            activeWageredAmount={this.props.modal.activeWageredAmount}
            settledWageredAmount={this.props.modal.settledWageredAmount}
            myBetsCounterToggle={this.props.modal.myBetsCounterToggle}
            futureWageredAmount={this.props.modal.futureWageredAmount}
          />
          <PromosModal
            isVideoShown={this.props.showVideo}
            isOpen={this.props.modal.promosOpen}
            isLogged={this.props.user.isLogged}
            dispatch={this.props.dispatch}
            history={this.props.history}
            currentPath={currentPath}
            promoPage={get(queryParameters, "promo", "promos")}
            device={get(this.tvg, "device")}
            accountNumber={this.props.user.accountNumber}
            optedInPromos={this.props.user.optedInPromos}
            homeState={this.props.user.homeState}
          />
          <HandicapStoreModal
            isVideoShown={this.props.showVideo}
            isOpen={this.props.modal.handicappingStore.isOpen}
            iFrameUrl={getHandicapStoreUrl(
              this.props.modal.handicappingStore.url,
              this.props.user.isLogged
            )}
            dispatch={this.props.dispatch}
            history={this.props.history}
            currentPath={currentPath}
            device={get(this.tvg, "device")}
            product={get(this.tvg, "product")}
            className={styles.iframeScrollWrapper}
            hasHeader={this.props.modal.handicappingStore.isModalHasHeader}
            errorMessage={get(
              this.props,
              "messages.equibaseErrorLoadingMessage",
              ""
            )}
          />
          <AccountWalletModal
            BaseComponent={ModalV2}
            modalTopChildren={this.modalTopChildren}
            isOpen={this.props.modal.accountWallet.open}
            title={this.props.modal.accountWallet.title}
            destinationPath={this.props.modal.accountWallet.path}
            currentPath={currentPath}
            dispatch={this.props.dispatch}
          />
          <FeatureTogglesModal
            dispatch={this.props.dispatch}
            featureToggles={this.props.featureToggles}
            isOpen={this.props.modal.featureTogglesOpen}
            history={this.props.history}
            currentPath={currentPath}
            device={get(this.tvg, "device")}
          />
          <TrackSelectorModal
            dispatch={this.props.dispatch}
            isOpen={this.props.modal.trackSelectorOpen}
            history={this.props.history}
            currentPath={currentPath}
            device={get(this.tvg, "device")}
          />
          <RaceSelectorModal
            dispatch={this.props.dispatch}
            isOpen={this.props.modal.raceSelectorOpen}
            history={this.props.history}
            currentPath={currentPath}
            device={get(this.tvg, "device")}
            trackTitle={this.props.trackTitle}
            numberOfRaces={this.props.numberOfRaces}
          />
          <HelpOpenModal
            dispatch={this.props.dispatch}
            isOpen={this.props.modal.helpModalOpen}
            currentPath={currentPath}
            history={this.props.history}
          />
          <WelcomeNewUserModal
            isOpen={this.props.isWelcomeNewUserOpen}
            dispatch={this.props.dispatch}
            history={this.props.history}
            currentPath={currentPath}
            userEmail={this.props.user.emailAddress}
            device={get(this.tvg, "device")}
          />
          <PotencialReturnModal
            isOpen={get(this.props, "potencialReturnInfo.isOpen")}
            hasMessage={get(this.props, "potencialReturnInfo.hasMessage")}
            parentPage={get(this.props, "potencialReturnInfo.parentPage")}
            dispatch={this.props.dispatch}
            currentPath={currentPath}
          />
          <PickBetsHowItWorksModal
            isOpen={get(this.props, "modal.isPickBetsModalOpen")}
            dispatch={this.props.dispatch}
            history={this.props.history}
            currentPath={currentPath}
          />
          <InvalidResidentialAddressErrorModal
            isOpen={get(
              this.props,
              "modal.isInvalidResidentialAddressModalOpen"
            )}
            dispatch={this.props.dispatch}
            errorMessages={
              this.props.invalidResidentialAddressMessage[
                isXSell() ? "xSell" : "standalone"
              ]
            }
            history={this.props.history}
          />
          <CrossProductNavigationModal
            isOpen={get(this.props, "modal.isCrossProductNavigationModalOpen")}
            onClose={() =>
              this.props.dispatch(closeCrossProductNavigationModal())
            }
          />
          {!isXSell() && (
            <GeoComplyErrorModal
              isOpen={get(this.props, "modal.geoComplyErrorOpen")}
              isErrorRetryable={this.props.geolocationErrorRetryable}
              dispatch={this.props.dispatch}
              errorsMessages={getRejectedErrorTitle(
                this.props.geoLocationRejectedErrorModalTitle,
                this.props.geolocationError[this.props.geolocationStatus]
              )}
              errorsTitle={`We've found ${pluralize(
                this.props.geolocationError[this.props.geolocationStatus]
                  ?.length,
                "error"
              )}`}
              title={
                this.props.geoLocationErrorModalTitle[
                  this.props.geolocationStatus
                ]
              }
              currentPath={currentPath}
              imageType={
                this.props.geolocationStatus === "GEOLOCATION_REJECTED"
                  ? MapImageEnum.ERROR
                  : MapImageEnum.PIN
              }
              onDismiss={() => this.props.dispatch(geoComplyErrorModal())}
              onClickPrimaryButton={() => {
                this.props.dispatch(geoComplyErrorModal());
                onTriggerGeolocation();
              }}
              onClickSecondaryButton={() => {
                this.props.dispatch(geoComplyErrorModal());
                openLiveChat();
              }}
              geolocationStatus={this.props.geolocationStatus}
              errorDescription={get(
                this.props.geoLocationErrorModalTips,
                this.props.geolocationStatus,
                this.props.geoLocationErrorModalTips.LOCATION_FAILURE
              )}
            />
          )}
          <LocationSplash history={this.props.history} />
          {!this.state.hasShownForceUpdate && (
            <StateSelector
              currentPath={currentPath}
              onClose={this.handleStateSelectorClose}
            />
          )}
          <Messenger />
          {this.props.enableOnboardings && (
            <Onboardings
              history={this.props.history}
              location={this.props.location}
              device={get(this.tvg, "device")}
              isEducationalHub={this.props.enableEducationalHub}
            />
          )}
          {this.props.betCancelModalToggle && (
            <BetCancelModal
              isOpen={
                get(this.props, "modal.betCancelModalOpen") &&
                get(this.props, "modal.myBetsStandaloneOpen")
              }
              dispatch={this.props.dispatch}
              history={this.props.history}
              currentPath={currentPath}
              device={get(this.tvg, "device")}
              isLoading={this.props.isLoadingBetCancelRequest}
              betCancelModalProcessingTitleLabel={
                this.props.betCancelModalProcessingTitleLabel
              }
              betCancelModalConfirmTitleLabel={
                this.props.betCancelModalConfirmTitleLabel
              }
            />
          )}
          {this.props.betSocialShareModalToggle && (
            <BetSocialShareModal
              isOpen={get(this.props, "modal.betSocialShareModalOpen")}
              dispatch={this.props.dispatch}
              history={this.props.history}
              currentPath={currentPath}
              device={get(this.tvg, "device")}
              isLoading={false}
            />
          )}
          <ApproxPayoutHelpModal
            isOpen={this.props.modal.approxPayoutModalOpen}
            dispatch={this.props.dispatch}
            device={get(this.tvg, "device")}
            approximatePayoutModalTitleLabel={
              this.props.approximatePayoutModalTitleLabel
            }
          />
          {!this.props.hasConnection && (
            <ErrorPage
              showClose={false}
              iconType="noWifi"
              message={{
                title: "No Internet Connection",
                text: "It looks like you're not connected to the Internet, please check you're connected and try again."
              }}
              boxType="noInternetConnection"
              boxLabels={{
                primaryButton: "Retry"
              }}
              handleButton={() => location.reload()}
            />
          )}
          {this.props.showLoadingSplash &&
            get(this.props, "query.splash", "0") === "1" && (
              <SplashLoader messages={this.props.beforeLoadingMessages} />
            )}
        </Fragment>
      </FeedbackMessageContext.Provider>
    );
  }
}

const mapStateToProps = (store: Store) => ({
  userFavoriteTracksLoaded: get(store, "userFavorites.tracksLoaded", false),
  behgToggle: get(store, "capi.featureToggles.myBetsBehgConnection", false),
  user: {
    isLogged: store.userData.logged,
    balance: store.userData.balance,
    balancePoller: store.userData.balancePoller,
    wagerProfile: get(store, "userData.user.profile"),
    accountNumber: getAccountNumber(store),
    userName: get(store, "userData.user.userName"),
    firstName: get(store, "userData.user.firstName"),
    lastName: get(store, "userData.user.lastName"),
    homeState: getResidenceState(store),
    emailAddress: getEmail(store),
    optedInPromos: get(store, "userData.optedInPromos", ""),
    sessionStartAt: get(store, "userData.sessionStartAt"),
    isVerified: get(store, "userData.isVerified"),
    isTermsAccepted: get(store, "userData.jurisdiction.accepted"),
    jurisdiction: get(store, "userData.jurisdiction.jurisdiction"),
    isAccountCompliant: isAccountCompliantSelector(store),
    fdUserId: get(store, "userData.user.fdUserId")
  },
  hasPromoBadge: get(store, "capi.featureToggles.promosDisplayBadge", false),
  talentPicksPageEnable: get(
    store,
    "capi.featureToggles.talentPicksPageEnable",
    false
  ),
  isBalanceShown: get(store, "userData.preferences.balance_is_shown", "0"),
  isBetslipOpen: get(store, "BetTicket.betSlipOpen", false),
  isFooterVisible:
    !get(store, "RaceProgram.startBetting", false) ||
    !get(store, "RaceProgram.betType", false),
  messages: store.capi.messages,
  featureToggles: get(store, "capi.featureToggles"),
  features: get(store, "capi.features"),
  accountCompliantBannerMsg: parseJSONCapiMessage(
    store,
    "capi.messages.accountCompliantBannerMsg"
  ),
  geolocationBannerMsg: parseJSONCapiMessage(
    store,
    "capi.messages.geoLocationBannerMsg"
  ),
  iOSWrapperConfig: parseJSONCapiMessage(
    store,
    "capi.messages.iOSWrapperConfig"
  ),
  capiIOSForceUpdateFDR: parseJSONCapiMessage(
    store,
    "capi.messages.iOSForceUpdateFDR"
  ),
  betCancelModalProcessingTitleLabel: get(
    store,
    "capi.messages.BetCancelModalProcessingTitleLabel",
    "Processing Cancellation..."
  ),
  betCancelModalConfirmTitleLabel: get(
    store,
    "capi.messages.BetCancelModalConfirmTitleLabel",
    "Confirm Cancellation"
  ),
  approximatePayoutModalTitleLabel: get(
    store,
    "capi.messages.ApproximatePayoutModalTitleLabel",
    "Approximate Payout"
  ),
  geolocation: store.geolocation,
  showVideo: store.RaceProgramVideo.show,
  modal: {
    ...store.modal,
    myBetsOpen: store.myBets.isOpen,
    myBetsStandaloneOpen: store.myBetsStandalone.isOpen,
    betCancelModalOpen: getBetCancelIsOpen(store),
    betSocialShareModalOpen: getBetSocialShareIsOpen(store),
    approxPayoutModalOpen: getIsApproxPayoutModalOpen(store),
    myBetsCounterToggle: getMyBetsCounterToggle(store),
    activeBetsCounter: getTodayActiveCounter(store),
    settledBetsCounter: getTodaySettledCounter(store),
    futureBetsCounter: getTodayFutureCounter(store),
    activeWageredAmount: getActiveWageredAmountCounter(store),
    settledWageredAmount: getSettledWageredAmountCounter(store),
    futureWageredAmount: getFutureWageredAmountCounter(store),
    myBetsStandalonePastPerformanceOpen: getIsMyBetsPastPerformanceOpen(store),
    myBetsStandalonePastPerformanceTitle: getPastPerformanceModaLTitle(store)
  },
  approxPayoutModalOpen: get(
    store,
    "myBetsStandalone.approxPayoutModal.isOpen",
    false
  ),
  touchId: {
    initEnabled: get(store, "ios.init.touchIdEnabled"),
    enabled: get(store, "ios.touchId.touchIdEnabled"),
    accountId: get(store, "ios.touchId.accountId"),
    userChangingTouchId: get(store, "ios.userChangingTouchId"),
    token: get(store, "ios.touchId.token")
  },
  mobileLaunchTimestamp: get(store, "ios.init.launchTimestamp", 0),
  isActiveBetsModal: store.myBets.isActiveBets,
  currentRace: store.RaceProgram.currentRace,
  hasPromosOptedIn: get(
    store,
    "capi.featureToggles.promosDisplayOptedIn",
    false
  ),
  startBetting: get(store, "RaceProgram.startBetting", false),
  enableOnboardings: get(store, "capi.featureToggles.enableOnboardings", false),
  showLoadingSplash: get(store, "capi.featureToggles.showLoadingSplash", false),
  wagerRewardsApp: get(store, "capi.featureToggles.wagerRewardsApp", false),
  appVersion: get(store, "ios.init.appVersion", ""),
  isBeta: store.app.isBeta,
  isWelcomeNewUserOpen: get(store, "modal.welcomeNewUserOpen", false),
  enablePromosStoryblok: get(
    store,
    "capi.featureToggles.enablePromosStoryblok",
    false
  ),
  potencialReturnInfo: get(store, "modal.potencialReturn", {
    isOpen: false,
    hasMessage: false,
    parentPage: "programPage"
  }),
  hasConnection: get(store, "app.hasConnection", true),
  isPromosEnabled: get(store, "capi.featureToggles.isPromosEnabled", false),
  brazePageViewEvent: get(
    store,
    "capi.featureToggles.brazePageViewEvent",
    false
  ),
  currentTvgRaceId: get(store, "myBets.tvgRaceId", 0),
  racesActiveBets: get(store, "myBets.racesActiveBets", {}),
  trackTitle: get(
    store,
    "RaceProgram.currentRace.track.trackName",
    "Track Races"
  ),
  brazeHeaderInAppMessaging: get(
    store,
    "capi.featureToggles.brazeHeaderInAppMessaging",
    false
  ),
  numberOfRaces: get(store, "RaceProgram.currentRace.track.numberOfRaces", 0),
  enablePerimeterX: get(
    store,
    "capi.featureToggles.enablePerimeterxFDR",
    false
  ),
  refreshSessionPollerTimer: get(
    store,
    "capi.messages.refreshSessionPollerTimer",
    3000
  ),
  geolocationStatus: getGeolocationStatus(store),
  geolocationMessageShown: getGeolocationMessageShown(store),
  geolocationError: get(store, "geolocation.geolocationError", {}),
  geolocationErrorRetryable: get(store, "geolocation.isErrorRetryable"),
  geoLocationToastMsg: parseJSONCapiMessage(
    store,
    "capi.messages.geoLocationToastMsg",
    {}
  ),
  geoLocationErrorModalTips: parseJSONCapiMessage(
    store,
    "capi.messages.geoLocationErrorModalTips",
    {}
  ),
  geoLocationErrorModalTitle: parseJSONCapiMessage(
    store,
    "capi.messages.geoLocationErrorModalTitle",
    {}
  ),
  geoLocationRejectedErrorModalTitle: parseJSONCapiMessage(
    store,
    "capi.messages.geoLocationRejectedErrorModalTitle",
    {}
  ),
  geoComplyRetryStatus: getGeoComplyRetryStatus(store),
  allowedStates: Object.keys(
    parseJSONCapiMessage(
      store,
      `capi.messages.${
        tvgConf().product === "fdrandroidgps"
          ? "stateSelectorListFdrAndroidGPS"
          : "stateSelectorListFdr"
      }`,
      {}
    )
  ),
  twoFactorAuthStates: parseJSONCapiMessage(
    store,
    "capi.messages.twoFactorAuthStates",
    []
  ),
  overwritePreferences: parseJSONCapiMessage(
    store,
    "capi.messages.overwritePreferences",
    {}
  ),
  invalidResidentialAddressMessage: parseJSONCapiMessage(
    store,
    "capi.messages.invalidResidentialAddressError",
    {}
  ),
  enableEducationalHub: get(
    store,
    "capi.featureToggles.enableEducationalHub",
    false
  ),
  enableAmplitude: get(store, "capi.featureToggles.useAmplitude", false),
  enableRetryGeocomply: get(
    store,
    "capi.featureToggles.enableRetryGeocomply",
    false
  ),
  raceDate: get(store, "mtpStatus.raceDate"),
  enableNoLoginRequiredForAccountPage: get(
    store,
    "capi.featureToggles.enableNoLoginRequiredForAccountPage",
    false
  ),
  geolocationGPSInvalidMessage: parseJSONCapiMessage(
    store,
    "capi.messages.geoLocationGPStoreStateInvalid",
    {}
  ),
  enableURPWatchFDTV: get(
    store,
    "capi.featureToggles.enableURPWatchFDTV",
    false
  ),
  isLoadingBetCancelRequest: getBetCancelIsLoadingBetCancelRequest(store),
  myBetsStandaloneToggle: getMyBetsStandaloneToggle(store),
  betCancelModalToggle: getBetCancelModalToggle(store),
  myBetsStandalone: {
    selectedTab: getSelectedTab(store),
    selectedSettledTab: getSelectedSettledTab(store)
  },
  brazeContentCards: get(store, "brazeData.brazeContentCards", {}),
  brazePoller: get(store, "brazeData.brazePoller", 60),
  contentCardsOpen: get(store, "brazeInbox.isModalOpen"),
  disableGWallet: get(store, "capi.featureToggles.disableGWallet")
});

export default withRouter(connect(mapStateToProps)(Root));
